import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  GenerateReportPdfMutation,
  GenerateReportPdfMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const generateReportPdf = graphql(`
  mutation generateReportPdf($id: String!) {
    generateReportPdf(id: $id) {
      id
    }
  }
`);

// Kicks off an async report PDF export and returns the export id. Subscribe to
// the export via useFileExportStatus with that id to get the download URL.
export function useExportReports(
  options?: UseMutationOptions<
    GenerateReportPdfMutation,
    unknown,
    GenerateReportPdfMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(generateReportPdf, options);
  return { data: data?.generateReportPdf, ...rest };
}
